import styled from 'styled-components'

export const FormShell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    width: 100%;
`

export default FormShell
